import type { SVGProps } from "react";
import { memo } from "react";
const Rekognition = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80" {...props}>
    <defs>
      <linearGradient id="prefix__a" x1="0%" x2="100%" y1="100%" y2="0%">
        <stop offset="0%" stopColor="#055F4E" />
        <stop offset="100%" stopColor="#56C0A7" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path fill="url(#prefix__a)" d="M0 0h80v80H0z" />
      <path
        fill="#FFF"
        d="M65.327 60.322 51.915 47.266a22.3 22.3 0 0 1-4.658 4.66l13.088 13.397c.648.649 1.417.704 1.948.638.812-.104 1.655-.557 2.375-1.276.722-.723 1.182-1.574 1.29-2.397.072-.536.02-1.313-.631-1.966m-31.203-6.078c11.087 0 20.106-9.023 20.106-20.113s-9.019-20.114-20.106-20.114-20.107 9.023-20.107 20.114c0 11.09 9.02 20.113 20.107 20.113m33.833 8.312c-.168 1.258-.83 2.521-1.863 3.555-1.035 1.034-2.293 1.691-3.546 1.85a5 5 0 0 1-.6.039 4.23 4.23 0 0 1-3.037-1.259l-13.354-13.67a22 22 0 0 1-11.433 3.19C21.924 56.26 12 46.333 12 34.13 12 21.928 21.925 12 34.124 12s22.123 9.928 22.123 22.13c0 4.182-1.166 8.095-3.188 11.434l13.683 13.322c.974.974 1.402 2.274 1.215 3.67M48.24 34.13c0-7.919-6.2-14.12-14.116-14.12s-14.116 6.201-14.116 14.12c0 7.917 6.2 14.12 14.116 14.12s14.116-6.203 14.116-14.12m2.017 0c0 9.05-7.088 16.138-16.133 16.138-9.046 0-16.133-7.089-16.133-16.138s7.087-16.138 16.133-16.138 16.133 7.089 16.133 16.138M27.9 36.974h-2.017v5.043h5.042V40H27.9zm-2.017-6.051h2.017v-3.026h3.025v-2.018h-5.042zm11.091-3.026H40v3.026h2.017v-5.044h-5.042zM40 36.974h2.017v5.043h-5.042V40H40z"
      />
    </g>
  </svg>
);
const Memo = memo(Rekognition);
export default Memo;
